import { Button } from '@amzn/awsui-components-react';
import React from 'react';
import { AreYouSureConsentModal } from './AreYouSureConsentModal';
import { GandalfUser } from '../types/auth';
import { AppConfig } from '../types/app';

const DenyConsent = ({
  onContinue,
  buttonLabel,
  user,
  onCancel,
  config,
  disabled = false,
  setConsentInProgress,
}: {
  onContinue: () => void;
  buttonLabel: string;
  user: GandalfUser;
  onCancel: () => void;
  config: AppConfig;
  disabled?: boolean;
  setConsentInProgress?: (inProgress: boolean) => void;
}) => {
  const [visible, setVisible] = React.useState(false);
  return (
    <>
      <Button
        onClick={(e) => {
          e.preventDefault();
          setVisible(true);
        }}
        variant="link"
        data-testid={'deny-consent'}
        disabled={disabled}
      >
        {buttonLabel}
      </Button>
      {visible ? (
        <AreYouSureConsentModal
          user={user}
          onContinue={onContinue}
          onCancel={onCancel}
          config={config}
          setParentVisibleState={setVisible}
          setConsentInProgress={setConsentInProgress}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default DenyConsent;
